import { render, staticRenderFns } from "./FormControlTemplatesTemplatesLazyLoad.vue?vue&type=template&id=b6eeeeae"
import script from "./FormControlTemplatesTemplatesLazyLoad.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTemplatesTemplatesLazyLoad.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports